import React from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./DownloadButton.module.scss";

const StyledButton = styled(Button)({
  minWidth: 0,
});

const StyledSaveAltIcon = styled(SaveAltIcon)({
  height: 18,
  margin: 2,
  width: 18,
  padding: 0,
});

const DownloadButton = (props) => {
  return (
    <StyledButton onClick={props.download}>
      <div className={styles.download}>
        <div>{props.text}</div>
        <StyledSaveAltIcon />
      </div>
    </StyledButton>
  );
};

export default DownloadButton;
